var map = {
	"./anders": 67,
	"./anders.jpg": 67,
	"./arrow": 68,
	"./arrow.svg": 68,
	"./avatar-1": 69,
	"./avatar-1.jpg": 69,
	"./avatar-2": 70,
	"./avatar-2.jpg": 70,
	"./avatar-3": 71,
	"./avatar-3.jpg": 71,
	"./bottle": 72,
	"./bottle-pattern": 73,
	"./bottle-pattern.svg": 73,
	"./bottle.svg": 72,
	"./bottles-outline": 74,
	"./bottles-outline.svg": 74,
	"./close": 75,
	"./close-alt": 76,
	"./close-alt.svg": 76,
	"./close.svg": 75,
	"./fine-wine-bottle": 77,
	"./fine-wine-bottle.webp": 77,
	"./fine-wines": 78,
	"./fine-wines.webp": 78,
	"./frontend/about_first": 79,
	"./frontend/about_first.webp": 79,
	"./frontend/about_second": 80,
	"./frontend/about_second.webp": 80,
	"./frontend/arrow_down": 81,
	"./frontend/arrow_down.svg": 81,
	"./frontend/blue": 82,
	"./frontend/blue.png": 82,
	"./frontend/clock": 83,
	"./frontend/clock.svg": 83,
	"./frontend/close": 84,
	"./frontend/close.svg": 84,
	"./frontend/edit": 85,
	"./frontend/edit.svg": 85,
	"./frontend/facebook": 52,
	"./frontend/facebook.png": 52,
	"./frontend/facebook.svg": 128,
	"./frontend/greater": 86,
	"./frontend/greater.svg": 86,
	"./frontend/instagram": 53,
	"./frontend/instagram.png": 53,
	"./frontend/instagram.svg": 129,
	"./frontend/less": 87,
	"./frontend/less.svg": 87,
	"./frontend/linkedin": 54,
	"./frontend/linkedin.png": 54,
	"./frontend/linkedin.svg": 130,
	"./frontend/logo": 88,
	"./frontend/logo.svg": 88,
	"./frontend/map": 89,
	"./frontend/map.svg": 89,
	"./frontend/menu": 90,
	"./frontend/menu.svg": 90,
	"./frontend/min": 91,
	"./frontend/min.svg": 91,
	"./frontend/phone": 92,
	"./frontend/phone.svg": 92,
	"./frontend/plus": 93,
	"./frontend/plus.svg": 93,
	"./frontend/question_down": 94,
	"./frontend/question_down.svg": 94,
	"./frontend/search": 95,
	"./frontend/search.svg": 95,
	"./frontend/slide": 96,
	"./frontend/slide.webp": 96,
	"./frontend/today": 97,
	"./frontend/today.png": 97,
	"./frontend/twitter": 55,
	"./frontend/twitter.png": 55,
	"./frontend/twitter.svg": 131,
	"./frontend/yellow": 98,
	"./frontend/yellow.png": 98,
	"./h-bottle": 99,
	"./h-bottle.svg": 99,
	"./jero-iphone": 100,
	"./jero-iphone.webp": 100,
	"./jero-macbook": 101,
	"./jero-macbook.webp": 101,
	"./jeroboam": 102,
	"./jeroboam-narrow": 103,
	"./jeroboam-narrow.svg": 103,
	"./jeroboam.svg": 102,
	"./logo": 104,
	"./logo-payoff": 105,
	"./logo-payoff.svg": 105,
	"./logo-simple": 106,
	"./logo-simple.svg": 106,
	"./logo.svg": 104,
	"./magnus": 107,
	"./magnus.jpg": 107,
	"./market": 108,
	"./market-narrow": 109,
	"./market-narrow.svg": 109,
	"./market.svg": 108,
	"./martin": 110,
	"./martin.jpg": 110,
	"./nav": 111,
	"./nav.svg": 111,
	"./neonomics": 112,
	"./neonomics.svg": 112,
	"./tuscany": 113,
	"./tuscany.svg": 113,
	"./user_auth_bg": 114,
	"./user_auth_bg.svg": 114,
	"./wine-curve": 115,
	"./wine-curve.webp": 115,
	"./wine-icon": 116,
	"./wine-icon.svg": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;